'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _makeBlock = require('./plugins/makeBlock');

var pluginBlock = _interopRequireWildcard(_makeBlock);

var _makeModifiers = require('./plugins/makeModifiers');

var pluginModifiers = _interopRequireWildcard(_makeModifiers);

var _makeOriginalClass = require('./plugins/makeOriginalClass');

var pluginOriginalClass = _interopRequireWildcard(_makeOriginalClass);

var _filterObject = require('./filter-object');

var _filterObject2 = _interopRequireDefault(_filterObject);

var _trimClassName = require('./trim-class-name');

var _trimClassName2 = _interopRequireDefault(_trimClassName);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var basicPlugins = [pluginBlock, pluginModifiers, pluginOriginalClass];
var defaultDelimiters = {
  element: '__',
  modifier: '--'
};

exports.default = function (block) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (props) {
    var _options$delimiters = options.delimiters,
        delimiters = _options$delimiters === undefined ? defaultDelimiters : _options$delimiters,
        _options$plugins = options.plugins,
        plugins = _options$plugins === undefined ? [] : _options$plugins;

    var element = props.element,
        restProps = _objectWithoutProperties(props, ['element']);

    var blockName = block + (element ? '' + delimiters.element + element : '');

    var pluginsList = basicPlugins.concat(plugins);

    var makers = pluginsList.map(function (plugin) {
      return plugin.maker;
    });
    var propsToRemove = pluginsList.map(function (plugin) {
      return plugin.propsToRemove;
    }).filter(function (a) {
      return a;
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []);

    var classNamesList = makers.map(function (maker) {
      return maker(blockName, props, { delimiters: delimiters });
    });
    var className = (0, _trimClassName2.default)((0, _classnames2.default)(classNamesList));

    var knownProps = (0, _filterObject2.default)(restProps, propsToRemove);

    return _extends({}, knownProps, { className: className });
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dumb-bem/lib/index.js
// module id = 13
// module chunks = 0